module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4407-1aae4b7676d0ad53acdd7ac17160c356.jpg";